import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import Button from '../../components/common/Button';
import EmptyState from '../../components/common/EmptyState';

const UnauthorizedPage = () => (
  <div className="min-h-[60vh] flex items-center justify-center p-6">
    <div className="max-w-md w-full">
      <EmptyState
        icon={Lock}
        title="Acesso não autorizado"
        description="Você não tem permissão pra ver esta página."
        action={
          <div className="flex gap-2 justify-center">
            <Link to="/">
              <Button variant="subtle">Home</Button>
            </Link>
            <Link to="/entrar">
              <Button>Entrar</Button>
            </Link>
          </div>
        }
      />
    </div>
  </div>
);

export default UnauthorizedPage;
